// @ts-nocheck

/**
 * * `PURCHASE` - Purchase (Pack)
 * `SUBSCRIPTION` - Subscription Grant
 * `CONSUME` - Usage
 * `RESET` - Cycle Reset
 * `GRANT` - Admin Grant
 * `REFUND` - Refund
 */
export type TransactionTypeEnum =
  typeof TransactionTypeEnum[keyof typeof TransactionTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionTypeEnum = {
  PURCHASE: "PURCHASE",
  SUBSCRIPTION: "SUBSCRIPTION",
  CONSUME: "CONSUME",
  RESET: "RESET",
  GRANT: "GRANT",
  REFUND: "REFUND",
} as const;
